require("./styles/main.scss");
import 'viewerjs/dist/viewer.css'
import viewer from 'v-viewer'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuelidate from 'vuelidate'
import Meta from 'vue-meta'
import App from "./App";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(viewer, {defaultOptions:{navbar:false,zIndex:1000000,title:false,toolbar: {
    zoomIn: 0,
    zoomOut: 0,
    oneToOne: 0,
    reset: 0,
    prev: 4,
    play: {
      show: 0,
      size: 'large',
    },
    next: 4,
    rotateLeft: 0,
    rotateRight: 0,
    flipHorizontal: 0,
    flipVertical: 0,
  }}});
Vue.use(Meta, {
    keyName: "metaInfo",
    attribute: 'data-vue-meta', // the attribute name vue-meta adds to the tags it observes
    ssrAttribute: 'data-vue-meta-server-rendered', // the attribute name that lets vue-meta know that meta info has already been server-rendered
    tagIDKeyName: 'vmid'
})

/* router.beforeEach((to, from, next) => {
    console.log(next)
    //next({ path: '/asdj/' })
}) */

//replace({ path: '/', redirect: router.base + '/startseite' })
/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    components: { App },
    template: "<App/>"


})


// WEBPACK FOOTER //
// ./src/main.js